<template>
	<div class="InvoiceAddr" >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-fapiaoguanli Icon"></i>
			<!-- <span class="p-l-10 p-r-10">/</span> -->
			<span class="header_text">/ 发票管理 / 快递信息</span>
		</div>

		<div class="content_Box box-shadow m-t-15" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<div class="p-l-10 p-r-10">
				<span class="addOK m-r-10" v-if="max5" @click="addInvoice()">新增快递地址</span>
				<b style="color:#C1C4CB;font-size: 12px;">最多支持5个收件地址</b>
			</div>
			<div class="tableMaxBox m-t-10">
				<template>
					<el-table :data="invoiceList" stripe style="width: 100%">
						<el-table-column prop="name" label="收件人" width="120px" :show-overflow-tooltip="true"></el-table-column>
						<el-table-column prop="mobile" label="联系电话" width="140px" :show-overflow-tooltip="true">
							<template slot-scope="{row,$index}">
								<span> {{row.mobile | vf_mobile}} </span>
							</template>	
						</el-table-column>
						<el-table-column prop="detail" label="详细地址" :show-overflow-tooltip="true">
							<template slot-scope="{row,$index}">
								<span>{{row.province}}—{{row.city}}—{{row.district}}{{row.detail}}</span>
							</template>	
						</el-table-column>
						<el-table-column label="操作" width="200" fixed="right">
							<template slot-scope="{row,$index}">
								<a class="cz-font cz-js cursor-pointer" @click="revamp(row)">修改</a>
								<span class="cz-line">|</span>
								<a class="cz-font cz-delete cursor-pointer" @click="deleteData(row)">删除</a>
								<span class="cz-line">|</span>
								<a class="cz-font cz-hd cursor-pointer" v-if="row.is_default==1"  @click="morenactive(row)">取消默认</a>
								<a class="cz-font cz-hd cursor-pointer" v-if="row.is_default==0"  @click="morenactive(row)">设默认</a>
							</template>
						</el-table-column>
					</el-table>
				</template>
			</div>
		</div>

		<!-- 弹框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="630px" :close-on-click-modal="false">
			<div class="auditCentent">
				<div class="row_box ">
					<div class="fl">
						<span><i class="zb zb-asterisk icon-wjx"></i> 添加发票地址：</span>
					</div>
					<div class="fl signRate">
						<el-select v-model="invoiceRevamp.province_id" filterable placeholder="选择省" @change="provinceChange" style="width: 140px;">
							<el-option v-for="(item,index) in provinceArr"  :key="item.name" :label="item.name" :value="item.id">
								<p>{{ item.name }}</p>
							</el-option>
						</el-select>
						<el-select v-model="invoiceRevamp.city_id" filterable placeholder="选择市" @change="cityChange" style="width: 140px;">
							<el-option v-for="(item,index) in cityArr" :key="item.id" :label="item.name" :value="item.id">
								<p>{{ item.name }}</p>
							</el-option>
						</el-select>
						<el-select v-model="invoiceRevamp.district_id" filterable placeholder="选区县" style="width: 140px;">
							<el-option v-for="(item,index) in countyArr" :key="item.id" :label="item.name" :value="item.id">
								<p>{{ item.name }}</p>
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><i class="zb zb-asterisk icon-wjx"></i><span> 详细地址：</span></div>
					<div class="fl w-430">
						<el-input v-model="invoiceRevamp.detail" placeholder="请输入详细地址"></el-input>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><i class="zb zb-asterisk icon-wjx"></i><span> 收件人：</span></div>
					<div class="fl w-430">
						<el-input v-model="invoiceRevamp.name" placeholder="请输入收件人"></el-input>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><i class="zb zb-asterisk icon-wjx"></i><span> 联系电话：</span></div>
					<div class="fl w-430">
						<el-input v-model="invoiceRevamp.mobile" placeholder="请输入联系电话"></el-input>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><i class="zb zb-asterisk icon-wjx"></i><span> 邮箱：</span></div>
					<div class="fl w-430">
						<el-input v-model="invoiceRevamp.email	" placeholder="请输入邮箱"></el-input>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<span class="btnOK" @click="submitBtn">确定</span>
				<span class="resetBtn" @click="cancelBtn">取消</span>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	export default {
		name: 'InvoiceAddr',
		data() {
			return {
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				screenHeight: document.documentElement.clientHeight,
				provinceArr: [], //省份
				cityArr: [], //城市
				countyArr:[],	//区/县
				max5:true, //最多5个
				url: common.url,
				invoiceList: [], //地址集合
				contract_rate: '',
				dialogShow: false, //弹框
				dialogTitle: '添加发票地址',
				invoiceRevamp: {
					province_id:'', //省
					city_id:'', //市
					district_id:'', //区
					name:'',	//收件人
					mobile:'',	//手机号
					detail:'',	//详细地址
					email:'',//邮箱
					id:''  
				},
				addrStorage:{},//修改原始存储
			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { // 判断是否登录
					window.location = 'login.html';
					return;
				}
				this.invoiceCategoryList();
				this.getDistrict();
			},
			getDistrict() { //省份
				this.$http.post(this.url + '/zhongfy/company/getDistrict').then((res) => {
					if (res.data.code == '200' || res.data.msg == '成功') {
						this.provinceArr = res.data.data
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					}
				}, (res) => {
					this.$message.error('网络错误');
				})
			},
			
			provinceClick(id) { //获取市
				let fn = new FormData();
				fn.append('id', id); //文件
				this.$http.post(this.url + '/zhongfy/company/getCity', fn).then((res) => {
					if (res.data.msg == '成功' || res.data.code == '200') {
						this.cityArr = res.data.data;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error('获取城市失败！');
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			cityClick(id){  //获取区/县
				let fn = new FormData();
				fn.append('id', id); //文件
				this.$http.post(this.url + '/zhongfy/company/getCounty', fn).then((res) => {
					if (res.data.msg == '成功' || res.data.code == '200') {
						this.countyArr = res.data.data;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error('获取城市失败！');
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			provinceChange(val) { //省份监听事件
				this.provinceClick(val); //获取市
				this.cityArr = []; //市数组清空
				this.countyArr = []; //区县数组清空
				this.invoiceRevamp.city_id = ''; //清空原选定的市
				this.invoiceRevamp.district_id = ''; //清空选定的区县
			},
			cityChange(val){//市监听事件
				this.cityClick(val);//获取区县
				this.countyArr = []; //区县数组清空
				this.invoiceRevamp.district_id = ''; //清空选定的区县
				this.district_id = ''; //清空原有的区
			},	
			invoiceCategoryList() { //获取发票地址列表
				this.$http.post(this.url + '/zhongfy/company/AddressList').then((res) => {
					if (res.data.msg == '查询成功' || res.data.code == '200') {
						this.invoiceList = res.data.data;
						if(this.invoiceList.length == '5'){
							this.max5 = false;
						}else{this.max5 = true;}
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error('获取失败！');
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			addInvoice() { //添加
				this.invoiceRevamp = {
					province_id:'', //省
					city_id:'', //市
					district_id:'', //区
					name:'',	//收件人
					mobile:'',	//手机号
					detail:'',	//详细地址
					email:'',//邮箱
					id:''  
				}
				this.dialogTitle = '添加发票地址',
				this.dialogShow = true;
			},
			revamp(row) { //修改
				this. addrStorage = JSON.parse(JSON.stringify(row))
				let obj = JSON.parse(JSON.stringify(row))
				this.invoiceRevamp = obj;
				this.invoiceRevamp.province_id = obj.province;
				this.invoiceRevamp.city_id = obj.city;
				this.invoiceRevamp.district_id = obj.district;
				this.dialogTitle = '修改发票地址',
				this.dialogShow = true;
				
				this.provinceClick(obj.province_id);
				this.provinceClick(obj.city_id);
			},
			submitBtn() { //ok
				if (this.invoiceRevamp.name == '' ||
					this.invoiceRevamp.mobile == '' ||
					this.invoiceRevamp.detail == '' ||
					this.invoiceRevamp.province_id == '' ||
					this.invoiceRevamp.city_id == '' ||
					this.invoiceRevamp.email == '' 
				 ) {
					this.$message.error('请输入必填项!');
					return;
				}
				let fn = new FormData();
				if (this.dialogTitle == '添加发票地址') {
					fn.append('name', this.invoiceRevamp.name);
					fn.append('mobile', this.invoiceRevamp.mobile);
					fn.append('detail', this.invoiceRevamp.detail);
					fn.append('province_id', this.invoiceRevamp.province_id);
					fn.append('city_id', this.invoiceRevamp.city_id);
					fn.append('district_id', this.invoiceRevamp.district_id);
					fn.append('email', this.invoiceRevamp.email);
					fn.append('id', '');
				}
				if (this.dialogTitle == '修改发票地址') {
					//一下3个if 省市区 没有做改变  那么久替换成原来的id
					if(isNaN(this.invoiceRevamp.province_id)){ 
						this.invoiceRevamp.province_id = this.addrStorage.province_id;
					}	
					if(isNaN(this.invoiceRevamp.city_id)){
						this.invoiceRevamp.city_id = this.addrStorage.city_id;
					}	
					if(isNaN(this.invoiceRevamp.district_id)){
						this.invoiceRevamp.district_id = this.addrStorage.district_id;
					}
					fn.append('name', this.invoiceRevamp.name);
					fn.append('mobile', this.invoiceRevamp.mobile);
					fn.append('detail', this.invoiceRevamp.detail);
					fn.append('province_id', this.invoiceRevamp.province_id);
					fn.append('city_id', this.invoiceRevamp.city_id);
					fn.append('district_id', this.invoiceRevamp.district_id);
					fn.append('email', this.invoiceRevamp.email);
					fn.append('id', this.invoiceRevamp.id);
				}
				this.$http.post(this.url + '/zhongfy/company/AddressSave', fn).then((res) => {
					if (res.data.code == '200') {
						this.invoiceCategoryList();
						this.dialogShow = false;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(res.data.msg);
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			cancelBtn() { //取消
				this.dialogShow = false;
			},
			morenactive(row) { //默认的地址
				let fn = new FormData();
				fn.append('id', row.id);
				this.$http.post(this.url + '/zhongfy/company/AddressDefault', fn).then((res) => {
					if (res.data.msg == '查询成功' || res.data.code == '200') {
						this.invoiceCategoryList();
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(res.data.msg);
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			deleteData(row) { //删除
				this.$confirm('您确定删除这条收件地址吗, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let fn = new FormData();
					fn.append('id', row.id);
					this.$http.post(this.url + '/zhongfy/company/AddressDel', fn).then((res) => {
						if (res.data.msg == '查询成功' || res.data.code == '200') {
							this.invoiceCategoryList();
						} else if (res.data.code == '8886') { //code   8886  登录过期
							sessionStorage.clear();
							this.$alert('登录已过期，请重新登录 !', '提示', {
								confirmButtonText: '确定',
								callback: action => {
									window.location = 'login.html';
								}
							});
							return;
						} else {
							this.$message.error(res.data.msg);
							return;
						}
					}, (res) => {
						this.$message.error('网络错误！');
						return;
					})
				}).catch(() => {
			
				});
			},
			gotToDetail(row) {
				this.$router.push({
					path: '/orderDetails',
					query: {
						id: row.id
					}
				})
			},
		},
		filters: {
			
		}
	}
</script>

<style scoped>
	.auditCentent i {font-size: 10px;}
	.auditCentent .row_box {min-height: 40px;}
	.auditCentent .row_box i {color: var(--theme-red);}
	.auditCentent .row_box>div:nth-child(1) {width: 110px;height: 40px;line-height: 40px;text-align: right;color: #666666;font-size: 12px;}
	.auditCentent .row_box>div:nth-child(2) {padding-left: 5px;height: 40px;line-height: 40px;color: var(--theme-black);font-size: 16px;}
	.auditCentent .reasonText {min-height: 90px;}
	.w-430{width: 430px;}
	.dialog-footer{text-align: left;padding-left: 114px;}
	.dialog-footer span{padding: 0 25px;}

	@media (max-width:767.78px) {
		.titleBox {height: 40px;}
	}
</style>



// WEBPACK FOOTER //
// src/components/InvoiceAddr.vue